import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Emitter } from '../../../base/common/event.js';
import { Disposable } from '../../../base/common/lifecycle.js';
export var ViewModelEventDispatcher = /*#__PURE__*/function (_Disposable) {
  _inherits(ViewModelEventDispatcher, _Disposable);

  var _super = _createSuper(ViewModelEventDispatcher);

  function ViewModelEventDispatcher() {
    var _this;

    _classCallCheck(this, ViewModelEventDispatcher);

    _this = _super.call(this);
    _this._onEvent = _this._register(new Emitter());
    _this.onEvent = _this._onEvent.event;
    _this._eventHandlers = [];
    _this._viewEventQueue = null;
    _this._isConsumingViewEventQueue = false;
    _this._collector = null;
    _this._collectorCnt = 0;
    _this._outgoingEvents = [];
    return _this;
  }

  _createClass(ViewModelEventDispatcher, [{
    key: "emitOutgoingEvent",
    value: function emitOutgoingEvent(e) {
      this._addOutgoingEvent(e);

      this._emitOugoingEvents();
    }
  }, {
    key: "_addOutgoingEvent",
    value: function _addOutgoingEvent(e) {
      for (var i = 0, len = this._outgoingEvents.length; i < len; i++) {
        if (this._outgoingEvents[i].kind === e.kind) {
          this._outgoingEvents[i] = this._outgoingEvents[i].merge(e);
          return;
        }
      } // not merged


      this._outgoingEvents.push(e);
    }
  }, {
    key: "_emitOugoingEvents",
    value: function _emitOugoingEvents() {
      while (this._outgoingEvents.length > 0) {
        if (this._collector || this._isConsumingViewEventQueue) {
          // right now collecting or emitting view events, so let's postpone emitting
          return;
        }

        var event = this._outgoingEvents.shift();

        if (event.isNoOp()) {
          continue;
        }

        this._onEvent.fire(event);
      }
    }
  }, {
    key: "addViewEventHandler",
    value: function addViewEventHandler(eventHandler) {
      for (var i = 0, len = this._eventHandlers.length; i < len; i++) {
        if (this._eventHandlers[i] === eventHandler) {
          console.warn('Detected duplicate listener in ViewEventDispatcher', eventHandler);
        }
      }

      this._eventHandlers.push(eventHandler);
    }
  }, {
    key: "removeViewEventHandler",
    value: function removeViewEventHandler(eventHandler) {
      for (var i = 0; i < this._eventHandlers.length; i++) {
        if (this._eventHandlers[i] === eventHandler) {
          this._eventHandlers.splice(i, 1);

          break;
        }
      }
    }
  }, {
    key: "beginEmitViewEvents",
    value: function beginEmitViewEvents() {
      this._collectorCnt++;

      if (this._collectorCnt === 1) {
        this._collector = new ViewModelEventsCollector();
      }

      return this._collector;
    }
  }, {
    key: "endEmitViewEvents",
    value: function endEmitViewEvents() {
      this._collectorCnt--;

      if (this._collectorCnt === 0) {
        var outgoingEvents = this._collector.outgoingEvents;
        var viewEvents = this._collector.viewEvents;
        this._collector = null;

        var _iterator = _createForOfIteratorHelper(outgoingEvents),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var outgoingEvent = _step.value;

            this._addOutgoingEvent(outgoingEvent);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (viewEvents.length > 0) {
          this._emitMany(viewEvents);
        }
      }

      this._emitOugoingEvents();
    }
  }, {
    key: "emitSingleViewEvent",
    value: function emitSingleViewEvent(event) {
      try {
        var eventsCollector = this.beginEmitViewEvents();
        eventsCollector.emitViewEvent(event);
      } finally {
        this.endEmitViewEvents();
      }
    }
  }, {
    key: "_emitMany",
    value: function _emitMany(events) {
      if (this._viewEventQueue) {
        this._viewEventQueue = this._viewEventQueue.concat(events);
      } else {
        this._viewEventQueue = events;
      }

      if (!this._isConsumingViewEventQueue) {
        this._consumeViewEventQueue();
      }
    }
  }, {
    key: "_consumeViewEventQueue",
    value: function _consumeViewEventQueue() {
      try {
        this._isConsumingViewEventQueue = true;

        this._doConsumeQueue();
      } finally {
        this._isConsumingViewEventQueue = false;
      }
    }
  }, {
    key: "_doConsumeQueue",
    value: function _doConsumeQueue() {
      while (this._viewEventQueue) {
        // Empty event queue, as events might come in while sending these off
        var events = this._viewEventQueue;
        this._viewEventQueue = null; // Use a clone of the event handlers list, as they might remove themselves

        var eventHandlers = this._eventHandlers.slice(0);

        var _iterator2 = _createForOfIteratorHelper(eventHandlers),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var eventHandler = _step2.value;
            eventHandler.handleEvents(events);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }]);

  return ViewModelEventDispatcher;
}(Disposable);
export var ViewModelEventsCollector = /*#__PURE__*/function () {
  function ViewModelEventsCollector() {
    _classCallCheck(this, ViewModelEventsCollector);

    this.viewEvents = [];
    this.outgoingEvents = [];
  }

  _createClass(ViewModelEventsCollector, [{
    key: "emitViewEvent",
    value: function emitViewEvent(event) {
      this.viewEvents.push(event);
    }
  }, {
    key: "emitOutgoingEvent",
    value: function emitOutgoingEvent(e) {
      this.outgoingEvents.push(e);
    }
  }]);

  return ViewModelEventsCollector;
}();
export var ContentSizeChangedEvent = /*#__PURE__*/function () {
  function ContentSizeChangedEvent(oldContentWidth, oldContentHeight, contentWidth, contentHeight) {
    _classCallCheck(this, ContentSizeChangedEvent);

    this.kind = 0
    /* ContentSizeChanged */
    ;
    this._oldContentWidth = oldContentWidth;
    this._oldContentHeight = oldContentHeight;
    this.contentWidth = contentWidth;
    this.contentHeight = contentHeight;
    this.contentWidthChanged = this._oldContentWidth !== this.contentWidth;
    this.contentHeightChanged = this._oldContentHeight !== this.contentHeight;
  }

  _createClass(ContentSizeChangedEvent, [{
    key: "isNoOp",
    value: function isNoOp() {
      return !this.contentWidthChanged && !this.contentHeightChanged;
    }
  }, {
    key: "merge",
    value: function merge(other) {
      if (other.kind !== 0
      /* ContentSizeChanged */
      ) {
        return this;
      }

      return new ContentSizeChangedEvent(this._oldContentWidth, this._oldContentHeight, other.contentWidth, other.contentHeight);
    }
  }]);

  return ContentSizeChangedEvent;
}();
export var FocusChangedEvent = /*#__PURE__*/function () {
  function FocusChangedEvent(oldHasFocus, hasFocus) {
    _classCallCheck(this, FocusChangedEvent);

    this.kind = 1
    /* FocusChanged */
    ;
    this.oldHasFocus = oldHasFocus;
    this.hasFocus = hasFocus;
  }

  _createClass(FocusChangedEvent, [{
    key: "isNoOp",
    value: function isNoOp() {
      return this.oldHasFocus === this.hasFocus;
    }
  }, {
    key: "merge",
    value: function merge(other) {
      if (other.kind !== 1
      /* FocusChanged */
      ) {
        return this;
      }

      return new FocusChangedEvent(this.oldHasFocus, other.hasFocus);
    }
  }]);

  return FocusChangedEvent;
}();
export var ScrollChangedEvent = /*#__PURE__*/function () {
  function ScrollChangedEvent(oldScrollWidth, oldScrollLeft, oldScrollHeight, oldScrollTop, scrollWidth, scrollLeft, scrollHeight, scrollTop) {
    _classCallCheck(this, ScrollChangedEvent);

    this.kind = 2
    /* ScrollChanged */
    ;
    this._oldScrollWidth = oldScrollWidth;
    this._oldScrollLeft = oldScrollLeft;
    this._oldScrollHeight = oldScrollHeight;
    this._oldScrollTop = oldScrollTop;
    this.scrollWidth = scrollWidth;
    this.scrollLeft = scrollLeft;
    this.scrollHeight = scrollHeight;
    this.scrollTop = scrollTop;
    this.scrollWidthChanged = this._oldScrollWidth !== this.scrollWidth;
    this.scrollLeftChanged = this._oldScrollLeft !== this.scrollLeft;
    this.scrollHeightChanged = this._oldScrollHeight !== this.scrollHeight;
    this.scrollTopChanged = this._oldScrollTop !== this.scrollTop;
  }

  _createClass(ScrollChangedEvent, [{
    key: "isNoOp",
    value: function isNoOp() {
      return !this.scrollWidthChanged && !this.scrollLeftChanged && !this.scrollHeightChanged && !this.scrollTopChanged;
    }
  }, {
    key: "merge",
    value: function merge(other) {
      if (other.kind !== 2
      /* ScrollChanged */
      ) {
        return this;
      }

      return new ScrollChangedEvent(this._oldScrollWidth, this._oldScrollLeft, this._oldScrollHeight, this._oldScrollTop, other.scrollWidth, other.scrollLeft, other.scrollHeight, other.scrollTop);
    }
  }]);

  return ScrollChangedEvent;
}();
export var ViewZonesChangedEvent = /*#__PURE__*/function () {
  function ViewZonesChangedEvent() {
    _classCallCheck(this, ViewZonesChangedEvent);

    this.kind = 3
    /* ViewZonesChanged */
    ;
  }

  _createClass(ViewZonesChangedEvent, [{
    key: "isNoOp",
    value: function isNoOp() {
      return false;
    }
  }, {
    key: "merge",
    value: function merge(other) {
      return this;
    }
  }]);

  return ViewZonesChangedEvent;
}();
export var CursorStateChangedEvent = /*#__PURE__*/function () {
  function CursorStateChangedEvent(oldSelections, selections, oldModelVersionId, modelVersionId, source, reason, reachedMaxCursorCount) {
    _classCallCheck(this, CursorStateChangedEvent);

    this.kind = 5
    /* CursorStateChanged */
    ;
    this.oldSelections = oldSelections;
    this.selections = selections;
    this.oldModelVersionId = oldModelVersionId;
    this.modelVersionId = modelVersionId;
    this.source = source;
    this.reason = reason;
    this.reachedMaxCursorCount = reachedMaxCursorCount;
  }

  _createClass(CursorStateChangedEvent, [{
    key: "isNoOp",
    value: function isNoOp() {
      return CursorStateChangedEvent._selectionsAreEqual(this.oldSelections, this.selections) && this.oldModelVersionId === this.modelVersionId;
    }
  }, {
    key: "merge",
    value: function merge(other) {
      if (other.kind !== 5
      /* CursorStateChanged */
      ) {
        return this;
      }

      return new CursorStateChangedEvent(this.oldSelections, other.selections, this.oldModelVersionId, other.modelVersionId, other.source, other.reason, this.reachedMaxCursorCount || other.reachedMaxCursorCount);
    }
  }], [{
    key: "_selectionsAreEqual",
    value: function _selectionsAreEqual(a, b) {
      if (!a && !b) {
        return true;
      }

      if (!a || !b) {
        return false;
      }

      var aLen = a.length;
      var bLen = b.length;

      if (aLen !== bLen) {
        return false;
      }

      for (var i = 0; i < aLen; i++) {
        if (!a[i].equalsSelection(b[i])) {
          return false;
        }
      }

      return true;
    }
  }]);

  return CursorStateChangedEvent;
}();
export var ReadOnlyEditAttemptEvent = /*#__PURE__*/function () {
  function ReadOnlyEditAttemptEvent() {
    _classCallCheck(this, ReadOnlyEditAttemptEvent);

    this.kind = 4
    /* ReadOnlyEditAttempt */
    ;
  }

  _createClass(ReadOnlyEditAttemptEvent, [{
    key: "isNoOp",
    value: function isNoOp() {
      return false;
    }
  }, {
    key: "merge",
    value: function merge(other) {
      return this;
    }
  }]);

  return ReadOnlyEditAttemptEvent;
}();